(function($, extra) {

    $(document).ready(function() {

        /** ELEMENTS */
        var
            $travel_agencies = $('.js-agency-listing'), // all travel agency containers
            $locations_select = $('#id_locations'), // location select dropdown
            $search_bar = $('.js-search-bar input'), // search bar
            $empty = $('.js-empty-agencies'), // no agencies from search

            CONTINENTS = extra.continent_codes, // continent codes present in form
            // static url taken from location app country model
            FLAG_URL_TEMPLATE_BEGINNING = '/static/location/img/flags/4x3/',
            FLAG_URL_TEMPLATE_END = '.svg',
            DEBOUNCE_INTERVAL = 330,

            // global filtering values
            locations_value = [],
            search_value = '';


        /** UTILITY FUNCTIONS */

        function debounce(func) {
            // utility function to set a debounce interval
            // on an active search bar
            var timer;

            return function() {
                var context = this,
                    args = arguments;

                // clear out any currently running timer
                clearTimeout(timer);

                // set a new timer and call 'func' if no new event occurs
                timer = setTimeout(function() {
                    func.apply(context, args);
                }, DEBOUNCE_INTERVAL);
            };
        }

        function handle_search_bar_input() {
            // do search bar value cleaning
            // pass value to global variable and trigger updater function
            // in separate function to allow debounce to work
            search_value = ($search_bar.val() || '')
                .toLowerCase()
                .replace(/[^a-z0-9]/g, '-')
                .replace(/-+/g, '-')
                .replace(/^-+|-+$/g, '');

            update_visible_agencies();
        }

        // debounced function call, used in event handler
        var debounced_handle_search_bar = debounce(handle_search_bar_input);

        /** UPDATER FUNCTIONS */

        function update_visible_agencies() {
            /**
             *  change what travel agencies are visible in response to user input in either or both of the filters:
             *      location and search bar
             *
             *  1. check location dropdown, if user has interacted with it, then apply filter
             *  2. check search bar, if user has interacted with it, then apply filter
             *      if user has already used location dropdown, apply filter to already-filtered selection
             *      otherwise apply filter to full list of agencies
             *  3. check if both filter values are empty and filtered selection is empty, this means user cleared
             *      their selection totally - so go back to showing all travel agencies
             *  4. apply filters to travel agencies on screen (if step 3 didn't occur)
             */
            var has_search = !!search_value,
                has_location = locations_value.length > 0,
                search = (search_value || '').split('-'),
                location = new Set(locations_value.map(function(x) {
                    return x.id;
                }));

            function search_matches(terms) {
                for (var i = 0; i < search.length; i++) {
                    var found = false;
                    for (var j = 0; j < terms.length; j++) {
                        if (terms[j].indexOf(search[i]) > -1) {
                            found = true;
                            break;
                        }
                    }
                    if (!found) {
                        return false;
                    }
                }
                return true;
            }

            $travel_agencies.each(function() {
                var $this = $(this),
                    slug = $this.data('slug').split('-'),
                    my_location = new Set($this.data('location').split('|')),
                    show = (!has_search && !has_location) ||
                        (has_search && !has_location && search_matches(slug)) ||
                        (!has_search && has_location && location.intersection(my_location).size > 0) ||
                        (has_search && has_location && search_matches(slug) && location.intersection(my_location).size > 0);

                $this.toggle(show);
            });

            $empty.toggle($travel_agencies.filter(':visible').length <= 0);
        }

        /** EVENT HANDLERS */

        // handle selecting a region
        $locations_select.on('select2:select', function() {
            // get the selected region, which is an array of objects
            locations_value = $locations_select.select2('data'); // assign global variable to current selection
            update_visible_agencies();
        });

        // show all agencies when location select is cleared
        $locations_select.on('select2:clear', function() {
            locations_value = []; // clear out locations selection
            update_visible_agencies();
        });

        // handle search bar input
        $search_bar.on('input', function(e) {
            e.preventDefault();

            // call delayed search bar functionality
            debounced_handle_search_bar();
        });

        /** INITIALIZATION */

        function add_flags(item) {
            /**
             * Add little country flags to select2 dropdown
             */
            // weed out the optgroup titles and continents
            if (!(item.element instanceof HTMLOptionElement)) { // optgroups
                return item.text;
            }
            if (CONTINENTS.includes(item.id)) { // continents
                return item.text;
            }

            // put together url with iso2 code
            var url = FLAG_URL_TEMPLATE_BEGINNING + item.id.toLowerCase() + FLAG_URL_TEMPLATE_END;

            // do some jquery magic: put the img together, then create the span with the item text, smash it together
            // then send that back to be rendered
            var img = $('<img>', {
                class: 'img-flag mr-2',
                width: '1.5rem',
                src: url,
                css: { 'border-radius': '6px' },
            });

            var span = $("<span>", {
                class: 'd-flex flex-row py-1',
                text: ' ' + item.text
            });
            span.prepend(img); // put flag before text

            return span;
        }

        // initialize dropdown select2
        $locations_select.select2({
            placeholder: 'Choose location',
            allowClear: true,
            width: '100%',
            dropdownCssClass: 'dropdown-container',
            templateResult: function(item) {
                return add_flags(item);
            },
        });
    });
})(window.jQuery, window.__extra);
